import axios from '@/axios.js'
import state from './state';

export default {
  async cancelAppointment({ commit, dispatch }, { id, isBooking }) {
    try {
      var request = await axios.post('/appointments/cancel', {
          appointment_id: id
      });
    } catch(e) {
      var request = e.response;
    }

    if (isBooking === undefined) {
      dispatch('notification/notification', request, {
        root: true
      });
    }

    if (request.data.success === false) {
      return;
    }

    commit('APPOINTMENTS_CANCEL', id);

    dispatch('user/updateServices', {
      services: request.data.services,
      type: 'push'
    }, { root: true });

    dispatch('layout/widget', true, { root: true });
  },

  changeAppointmentsAppearance({ commit }, appearance) {
    commit('APPOINTMENTS_APPEARANCE', appearance);
  },

  changeAppointmentsHistoryAppearance({ commit }, appearance) {
    commit('APPOINTMENTS_HISTORY_APPEARANCE', appearance);
  },

  async fetchAppointments({ commit }) {
    if (state.appointmentsLoading) {
      return;
    }

    state.appointmentsLoading = true;
    const request = await axios.get('/appointments');

    if (request.data.success === false) {
      request.data.appointments = [];
    }

    commit('APPOINTMENTS', request.data.appointments);
  },

  async fetchAppointmentsHistory({ commit }) {
    if (state.appointmentsHistoryLoading) {
      return;
    }

    state.appointmentsHistoryLoading = true;
    const request = await axios.get('/appointments/history');

    if (request.data.success === false) {
      request.data.appointments = [];
    }

    commit('APPOINTMENTS_HISTORY', request.data.appointments);
  },

  async storeAppointment({ dispatch }, data)  {
    dispatch('specialist/loadingBooking', true, { root: true });
    
    try {
      var request = await axios.post('/appointments/store', {
        start_timestamp : data.start_time,
        specialist_id   : data.specialistId,
        services        : data.services,
        timezone        : Intl.DateTimeFormat().resolvedOptions().timeZone
      });
    } catch(e) {
      var request = e.response;
    }

    dispatch('specialist/loadingBooking', false, { root: true });

    if (request.status === 200 && request.data.success === false) { //if payment required
      if (request.data.payment_ref) {
        request.data.payload ??= {};
        request.data.payload = data;
        request.data.entity = 'booking';

        dispatch('payments/openPayPending', request.data, { root: true })
      }
    } else if (request.status === 200) {
      dispatch('specialist/updateUserServices', {
        services: request.data.user.available_services_specialist,
        type: 'replace'
      }, { root: true });

      dispatch('user/updateServices', {
        services: request.data.user.available_services,
        type: 'replace'
      }, { root: true });

      dispatch('user/updateBalance', {
        amount: data.credits,
        type: 'debit'
      }, { root: true });

      dispatch('specialist/clearBooking', {}, { root: true });
      dispatch('layout/widget', true, { root: true });
    }

    dispatch('notification/notification', request, { root: true });
  }
}
